<template>
  <div id="app">
    <vc-parallax @before-destroy="onBeforeDestroy" @mounted="onMounted" @section-change="onSectionChange" :nav-color="configurator.navColor.model" :nav-type="configurator.navType.model" :nav-accent-color="configurator.navAccentColor.model" :nav-position="configurator.navPosition.model">
      <vc-parallax-section :color="configurator.sectionColor.model" backdrop="/docs/images/section-01.jpg">
        <info-block>
          <h1>Parallax for VueJs</h1>
          <p>VcParallax is a lightweight component, based on <a href="https://vuejs.org/" target="_blank">VueJs</a> for adding awesome parallax effects to web pages.
            Use the controls on the right to navigate to the <a href="##" @click.prevent="navigateToSectionByIndex(1)">next slide</a> to learn how to get started...</p>
        </info-block>
      </vc-parallax-section>
      <vc-parallax-section :color="configurator.sectionColor.model" :bg-color="configurator.sectionBgColor.model">
        <info-block title="Get Started">
          <p>The easiest way to start using VcParallax is to install it via NPM or Yarn:</p>
          <code-block>// npm
$ npm install vc-parallax --save
// yarn
$ yarn add vc-parallax</code-block>
          <p>Adding to a Vue project:</p>
          <code-block>import {VcParallax, VcParallaxSection} from 'vc-parallax'
// import the stylesheet
import '../node_modules/vc-parallax/dist/lib/vc-parallax.min.css'
// add to Vue
Vue.use(VcParallax)
Vue.use(VcParallaxSection)</code-block>
          <p>Then proceed to the <a href="#" @click.prevent="navigateToSectionByIndex(2)">configuration options</a>.
            Also, don't forget to check the <a href="#" @click.prevent="navigateToSectionByIndex(3)">events</a> emitted
            by the component and readme file for a complete overview of the component.</p>
        </info-block>
      </vc-parallax-section>
      <vc-parallax-section :color="configurator.sectionColor.model" backdrop="/docs/images/section-02.jpg">
        <info-block title="Configurator">
          <controls-list :configurator="configurator" />
          <p>* nav-accent-color: You need to select "scroll" nav-type in order for the changes to take effect</p>
          <code-viewer :configurator="configurator" />
          <p>Done here? Check the component <a href="#" @click.prevent="navigateToSectionByIndex(3)">events</a>.</p>
        </info-block>
      </vc-parallax-section>
      <vc-parallax-section :color="configurator.sectionColor.model" :bg-color="configurator.sectionBgColor.model">
        <info-block title="Component Events">
          <p>The component emits the following custom events:</p>
          <code-block>@mounted
@before-destroy
@section-change</code-block>
          <p>Check browser's console for the data returned by these events. To control the component from the outside,
            you can emit the <code>navigate-to-section</code> event to the <code>$root</code> of the app and pass the <code>index</code> of
            the section that you want to show:</p>
          <code-block>/**
  * Navigate to a parallax section by index
  * @method navigateToSectionByIndex
  * @param {number} index [index=0]
  * @return {void}
  */
  navigateToSectionByIndex (index = 0) {
  this.$root.$emit('navigate-to-section', index)
}</code-block>
          <p>That's all! Follow me <a href="https://twitter.com/vuecidity" target="_blank">@vuecidity</a>, check
            <a href="https://wemakesites.net" target="_blank">wemakesites.net</a> or my
            <a href="https://martinivanov.net" target="_blank">blog</a>.</p>
        </info-block>
      </vc-parallax-section>
    </vc-parallax>
    <social-bar />
  </div>
</template>
<script>
import configurator from './helpers/configurator'
import CodeViewer from './demo-components/code-viewer'
import InfoBlock from './demo-components/info-block'
import ControlsList from './demo-components/controls-list'
import SocialBar from './demo-components/social-bar'

export default {
  name: 'app',
  components: {
    SocialBar,
    InfoBlock,
    CodeViewer,
    ControlsList
  },
  mixins: [
    configurator
  ],
  methods: {
    /**
     * Navigate to a parallax section by index
     * @method navigateToSectionByIndex
     * @param {number} index [index=0]
     * @return {void}
     */
    navigateToSectionByIndex (index = 0) {
      this.$root.$emit('navigate-to-section', index)
    },
    /**
     * Handler for the section-change event of the component
     * @method onSectionChange
     * @param {object} data
     * @return {void}
     */
    onSectionChange (data) {
      this.log('section-change', data)
    },
    /**
     * Handler for the mounted event of the component
     * @method onMounted
     * @param {object} data
     * @return {void}
     */
    onMounted (data) {
      this.log('mounted', data)
    },
    /**
     * Handler for the before-destroy event of the component
     * @method onBeforeDestroy
     * @param {object} data
     * @return {void}
     */
    onBeforeDestroy (data) {
      this.log('before-destroy', data)
    },
    /**
     * Shortcut to console.log with additional fields
     * @method log
     * @param {string} data
     * @param {object} data
     * @return {void}
     */
    log (event, data) {
      console.log(`@${event}`, data)
    }
  }
}
</script>
<style>
h1, h2
{
  font-weight: normal;
}

p a
{
  color: #fff;
}

p code
{
  font-size: 1.25em;
  color: #b00;
}
</style>


// WEBPACK FOOTER //
// app.vue?40cc3aa4